/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Detail_Add_More_SlotsInputs */

const en_job_detail_add_more_slots = /** @type {(inputs: Job_Detail_Add_More_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add more appointments`)
};

const de_job_detail_add_more_slots = /** @type {(inputs: Job_Detail_Add_More_SlotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Termine hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add more appointments" |
*
* @param {Job_Detail_Add_More_SlotsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_detail_add_more_slots = /** @type {((inputs?: Job_Detail_Add_More_SlotsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Detail_Add_More_SlotsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_detail_add_more_slots(inputs)
	return en_job_detail_add_more_slots(inputs)
});